import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import config from '@/config'
const title = config.title

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: title + '-首页',
            mode: "history"
          }
        }, {
          path: '/half',
          name: 'half',
          component: resolve => require(['@/view/half'], resolve),
          meta: {
            title: title + '-装修产品'
          }
        }, {
          path: '/bureau',
          name: 'bureau',
          component: resolve => require(['@/view/bureau'], resolve),
          meta: {
            title: title + '-装修产品'
          }
        }, {
          path: '/design',
          name: 'design',
          component: resolve => require(['@/view/design'], resolve),
          meta: {
            title: title + '-设计案例'
          }
        }, {
          path: '/designer',
          name: 'designer',
          component: resolve => require(['@/view/designer'], resolve),
          meta: {
            title: title + '-团队'
          }
        },  {
          path: '/finish',
          name: 'finish',
          component: resolve => require(['@/view/finish'], resolve),
          meta: {
            title: title + '-完工案例'
          }
        }, {
          path: '/brand',
          name: 'brand',
          component: resolve => require(['@/view/brand'], resolve),
          meta: {
            title: title + '-品牌故事'
          }
        }, {
          path: '/news',
          name: 'news',
          component: resolve => require(['@/view/news'], resolve),
          meta: {
            title: title + '-企业动态'
          }
        }, {
          path: '/newsdetail',
          name: 'newsdetail',
          component: resolve => require(['@/view/newsdetail'], resolve),
          meta: {
            title: title
          }
        }, {
          path: '/designerdetail',
          name: 'designerdetail',
          component: resolve => require(['@/view/designerdetail'], resolve),
          meta: {
            title: title
          }
        },
        {
          path: '/contact',
          name: 'contact',
          component: resolve => require(['@/view/contact'], resolve),
          meta: {
            title: title + '-联系我们'
          }
        },
        {
          path: '/detail',
          name: 'detail',
          component: resolve => require(['@/view/detail'], resolve),
          meta: {
            title: title
          }
        },
        {
          path: '/detailvideo',
          name: 'detailvideo',
          component: resolve => require(['@/view/detailvideo'], resolve),
          meta: {
            title: title
          }
        },
        {
          path: '/real',
          name: 'real',
          component: resolve => require(['@/view/real'], resolve),
          meta: {
            title: title + '-视频案例'
          }
        },
        {
          path: '/project',
          name: 'project',
          component: resolve => require(['@/view/project'], resolve),
          meta: {
            title: title + '-金钻工程'
          }
        },
        {
          path: '/aftermarket',
          name: 'aftermarket',
          component: resolve => require(['@/view/aftermarket'], resolve),
          meta: {
            title: title + '-无忧售后'
          }
        },
        {
          path: '/lives',
          name: 'lives',
          component: resolve => require(['@/view/lives'], resolve),
          meta: {
            title: title + '-工地直播'
          }
        },
        {
          path: '/livesdetail',
          name: 'livesdetail',
          component: resolve => require(['@/view/livesdetail'], resolve),
          meta: {
            title: title + '-工地直播'
          }
        },
        {
          path: '/dianping',
          name: 'dianping',
          component: resolve => require(['@/view/dianping'], resolve),
          meta: {
            title: title + '-客户点评'
          }
        },
        {
          path: '/zuopin',
          name: 'zuopin',
          component: resolve => require(['@/view/zuopin'], resolve),
          meta: {
            title: title + '-作品'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js